module.exports = __webpack_public_path__ + "static/casio-874f7bae70a4421488728cd974a7aee2.png";